import { useTranslation } from 'react-i18next';
import { Skeleton } from '@monksflow/monks-ui';
import { useDelayedFlag } from '@/shared/hooks';

/**
 * The builder's body while it loads, shaped like what replaces it: the canvas card with the
 * palette in its corner and a few nodes. Held back for a moment, so a load that answers
 * at once never flashes it, and without an entrance of its own, so it is simply there and gone.
 */
export function AgentBuilderSkeleton() {
  const { t } = useTranslation('common');
  const show = useDelayedFlag(true);
  if (!show) return null;

  return (
    <div
      data-testid="agent-builder-skeleton"
      role="status"
      aria-busy="true"
      aria-label={t('loading')}
      className="flex h-full min-h-0 flex-col"
    >
      <div className="relative min-h-0 flex-1 overflow-hidden rounded-lg bg-card">
        <Skeleton className="absolute left-xs top-xs h-44 w-38 rounded-lg" />
        <div className="flex h-full flex-col items-center justify-center gap-2xl">
          <Skeleton className="h-10 w-50 rounded-lg" />
          <div className="flex gap-2xl">
            <Skeleton className="h-10 w-50 rounded-lg" />
            <Skeleton className="h-10 w-50 rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  );
}
